// extracted by mini-css-extract-plugin
module.exports = {"componentHolder":"PeykDiscountCode_componentHolder__1U9sH"};